import React from 'react';
import { RadioGroup } from '../../elements-inputs/radio-group';
import { ReviewStars } from '../inputs/stars';
import { ListingImage } from '../image/listing-image';
import { Avatar } from '../image/avatar';
import { FormBuilder } from '../forms/form';
import Reviews from 'api/api-reviews';
import { FormattedMessage, FormattedDate, injectIntl } from "react-intl";
import { Helpers } from '../helpers/helpers';
/*
Dependent Props:
- review
- user
- updateAction
- callback
*/

class ReviewForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      msgError: null,
      is_host: false,
      is_guest: false,
      review: null,
      reviewFor: null,
      starValCaptured: null,
      bookAgainCaptured: null,
      reviewTextCaptured: null
    };

    this.getReviewee = this.getReviewee.bind(this);
    this.captureStarRating = this.captureStarRating.bind(this);
    this.captureBookAgain = this.captureBookAgain.bind(this);
    this.captureReviewText = this.captureReviewText.bind(this);
    this.submitReview = this.submitReview.bind(this);
    this.submitReviewCb = this.submitReviewCb.bind(this);
    this.bookingAgainToggle = this.bookingAgainToggle.bind(this);
    this.renderReviewForm = this.renderReviewForm.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.validateInput = this.validateInput.bind(this);
  }

  getAccessToken () {
    let accessToken;
    if (this.props.params && this.props.params.accessToken) {
      accessToken = this.props.params.accessToken;
    } else if (document && document.cookie) {
      accessToken = PSSessions.Cookies.get('PSAccess');
    } else {
      accessToken = null;
    }
    return accessToken;
  }

  getReviewee () {
    const { review  = '' } = this.props;
    const {
      review_type = '',
      guest = '',
      listing = '',
      booking = '',
      use_type = ''
    } = review;

    const image = {
      ratio: 1.689,
      widths: [200],
      defaultWidth: 400,
      defaultHeight: 236,
      alt: 'Peerspace',
      imgId: listing ? listing.images[0].external_id : '',
      style: 'img-responsive listing-image'
    };
    if ('guest' === review_type) {
      return (
        <div className="guest-review flex column middle">
          <Avatar id={guest.avatar_id} />
          <h5 className="text-center ellipsis">{guest.name.first || ''} {guest.name.last || ''}</h5>
          <h5 className="text-center ellipsis full-width">{listing.title}</h5>
          <div className="text-gray-dark text-center">{use_type}</div>
          <div className="text-gray-dark text-center">
            <FormattedDate
              value={booking?.start?.display?.date}
              year="numeric"
              month="short"
              day="numeric"
              weekday="short"
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <ListingImage
          {...image}
        />
        <h5 className="text-left ellipsis full-width">{listing.title}</h5>
        <p className="text-gray-dark text-left">
          <FormattedDate
            value={booking?.start?.display?.date}
            year="numeric"
            month="short"
            day="numeric"
            weekday="short"
          />
        </p>
      </div>
    );
  }

  captureStarRating (starVal) {
    this.setState({ starValCaptured: parseInt(starVal, 10) });
  }

  captureBookAgain (selectedElement) {
    this.setState({ bookAgainCaptured: 'accepted' === selectedElement.value ? 'true' : 'false' });
  }

  captureReviewText (event, cb) {
    this.setState({
      reviewTextCaptured: event['review-message']
    });
    return cb();
  }

  validateInput (errorData, validState) {
    return validState(errorData);
  }

  submitReview (e, cb) {
    const accessToken = this.getAccessToken();
    const data = {
      stars: this.state.starValCaptured,
      review_text: this.state.reviewTextCaptured,
      would_you_book_again: 'true' === this.state.bookAgainCaptured
    };
    const reviewID = this.props.review._id;
    if (accessToken) {
      return Reviews.update(reviewID, accessToken, data, cb);
    }
  }

  submitReviewCb (response) {
    const reviewID = this.props.review._id;
    if (response.error || 400 < response.statusCode) {
      // Something went wrong when creating the message
      return this.setState({
        msgError: this.props.intl.formatMessage({ id: 'shared_components.review_form.something_wrong', defaultMessage: 'Something went wrong. Please try again.' })
      });
    }
    return this.props.cbAction(reviewID);
  }

  bookingAgainToggle () {
    const { review = {} } = this.props;
    const { review_type } = review;

    return (
      <div className="col-xs-12 margin-xl-top">
        <RadioGroup
          isRequired
          ref="radio"
          groupName="book-again"
          changeCB={this.captureBookAgain}
          customErrorMessage={this.props.intl.formatMessage({ id: 'shared_components.review_form.select_option', defaultMessage: 'Please select an option.' })}
          inputData={[
            {
              ID: 'yes',
              value: 'accepted',
              displayText: 'guest' === review_type
                ? this.props.intl.formatMessage({ id: 'shared_components.review_form.host_again', defaultMessage: 'Yes, I would host them again' })
                : this.props.intl.formatMessage({ id: 'shared_components.review_form.book_again', defaultMessage: 'Yes, I would book again' })
            },
            {
              ID: 'no',
              value: 'declined',
              displayText: 'guest' === review_type
                ? this.props.intl.formatMessage({ id: 'shared_components.review_form.not_host_again', defaultMessage: 'No, I would not host them again' })
                : this.props.intl.formatMessage({ id: 'shared_components.review_form.not_book_again', defaultMessage: 'No, I would not book again' })
            }
          ]}
        />
      </div>
    );
  }

  renderReviewForm (isMobile, revieweeName) {
    const reviewInputMetaData = [
      {
        inputFieldName: 'review_response',
        elementID: 'review-message',
        ref: 'reviewMsg',
        optional: false,
        actionFn: this.captureReviewText,
        actionCb: this.validateInput,
        placeholder: this.props.intl.formatMessage({ id: 'shared_components.review_form.leave_review_placeholder', defaultMessage: 'Leave a review' }),
        hideRequired: true
      },
      {
        custom: () => (<ReviewStars onChangeFn={this.captureStarRating} ref="review-stars" fullWidth/>)
      },
      {
        custom: this.bookingAgainToggle
      }
    ];
    const beforeCTA = isMobile ? (<div id="review-helper-text" className="border-bottom padding-lg-top padding-lg-bottom">
      <p className="padding-lg-left padding-lg-right text-gray-dark text-small">
        <FormattedMessage
          id='shared_components.review_form.update_bank_account_description'
          defaultMessage='Your review will be kept private until {revieweeName} completes their review.'
          values={{
            revieweeName: revieweeName
          }}
        />
      </p>
    </div>) : null;

    return (
      <FormBuilder
        ref="reviewForm"
        formStyle="standard"
        formname="review form"
        formInputs={reviewInputMetaData}
        submitAction={this.submitReview}
        submitCallback={this.submitReviewCb}
        isButtonDisabled={false}
        buttonText={this.props.intl.formatMessage({ id: 'shared_components.review_form.review_form_button', defaultMessage: 'Submit Review' })}
        buttonClass="btn btn-block btn-primary"
        errorText={this.state.msgError}
        beforeCTA={beforeCTA}
        ignoreTextAreaBlurValidation={true}
      />
    );
  }

  render () {
    const isMobile = Helpers.isMobile();
    let revieweeName;
    const revieweeInfo = this.getReviewee();
    const { review = {} } = this.props;
    const {
      review_type = '',
      guest = '',
      host = '',
      _id = ''
    } = review;
    if ('guest' === review_type) {
      revieweeName = guest?.name?.first || '';
    } else {
      revieweeName = host?.name?.first || '';
    }
    const currentReview = this.props.currentReview;
    const totalReviews = this.props?.totalReviews || 1;
    let displaySkipBtn;
    if ('guest' !== review_type || !this.props.snoozable) {
      displaySkipBtn = false;
    } else {
      displaySkipBtn = review.hasOwnProperty('allowed_to_skip') ? review.allowed_to_skip : true;
    }
    return (
      <div id="complete-review" className="complete-review flex">
        {!isMobile && <div id="review-form-left" className="review-form-left text-center flex column space-between border-right">
          {revieweeInfo}
          {<div id="review-helper-text" className="margin-auto-top">
            <p className="padding-lg-left padding-lg-right text-gray-dark text-small">
              <FormattedMessage
                id='shared_components.review_form.update_bank_account_description'
                defaultMessage='Your review will be kept private until {revieweeName} completes their review.'
                values={{
                  revieweeName: revieweeName
                }}
              />
            </p>
          </div>}
        </div>}
        <div id="review-form-right" className="review-form-right">
          <div className="venue_info">
            <p className={`text-primary ${isMobile ? 'text-center' : ''}`}>
              <FormattedMessage
                id='shared_components.review_form.review_pagination'
                defaultMessage='{currentReview} of {totalReviews} reviews'
                values={{
                  currentReview,
                  totalReviews
                }}
              />
            </p>
            <h3 className={`no-top-margin ${!isMobile || 'guest' !== review_type ? 'text-left' : 'text-center'}`}>
              { 'guest' === review_type
                ? (this.props.fromHostHub
                  ? this.props.intl.formatMessage(
                    {
                      id: 'host_hub.todo_list.leave_review_title',
                      defaultMessage: 'Leave {guest} a review'
                    },
                    { guest: revieweeName }
                  )
                  : this.props.intl.formatMessage(
                    {
                      id: 'shared_components.review_form.review_guest_name',
                      defaultMessage: 'Before continuing, leave {guest} a review'
                    },
                    { guest: revieweeName }
                  ))
                : this.props.intl.formatMessage(
                  { id: 'shared_components.review_form.review_space', defaultMessage: 'Review this space' }
                )
              }
            </h3>
            {isMobile && revieweeInfo}
            {isMobile && <br />}
            <p className={isMobile ? 'padding-xl-top border-top' : ''}>
              <FormattedMessage
                id='shared_components.review_form.feedback_will_help'
                defaultMessage='Your feedback will help other {reviewType} know what to expect. Please describe your experience booking with {revieweeName}.'
                values={{
                  reviewType: 'guest' === review_type ? 'hosts' : 'guests',
                  revieweeName: revieweeName
                }}
              />
            </p>
            <ul>
              <li>
                {'guest' === review_type
                  ? this.props.intl.formatMessage({ id: 'shared_components.review_form.easy_work_with', defaultMessage: 'How easy were they to work with?' })
                  : this.props.intl.formatMessage({ id: 'shared_components.review_form.responsive_was_host', defaultMessage: 'How responsive was the host?' })
                }
              </li>
              <li>
                {'guest' === review_type
                  ? this.props.intl.formatMessage({ id: 'shared_components.review_form.booking_go_planned', defaultMessage: 'Did the booking go as planned?' })
                  : this.props.intl.formatMessage({ id: 'shared_components.review_form.space_appear', defaultMessage: 'Did the space appear as advertised?' })
                }
              </li>
              <li className={isMobile ? 'padding-lg-bottom' : ''}>
                {'guest' === review_type
                  ? this.props.intl.formatMessage({ id: 'shared_components.review_form.follow_host_rules', defaultMessage: 'Did they follow your host rules?' })
                  : this.props.intl.formatMessage({ id: 'shared_components.review_form.activity_did_you_do', defaultMessage: 'What activity did you do in the the space?' })
                }
              </li>
            </ul>
          </div>
          { this.renderReviewForm(isMobile, revieweeName) }
          {displaySkipBtn && <button
            className="btn btn-block btn-no-outline"
            onClick={() => this.props.handleSnoozeBtn(_id)}
          >
            {this.props.intl.formatMessage({ id: 'shared_components.review_form.review_form_skip_button', defaultMessage: 'Snooze, I\'ll do this later' })}
          </button>}
        </div>
      </div>
    );
  }
}

const __e_ReviewForm = injectIntl(ReviewForm, { withRef: true });

export { __e_ReviewForm as ReviewForm };